import utils from "../../../utils/utils.js";

export default {
    async fetchFeedQueue(context, payload) {
        const feedId = payload.feedId;

        const response = await utils.utility.fetch(`api/Editor/GetQueuesByFeedId?feedId=${feedId}`, "GET", null, null);
        
        context.commit("setFeedQueue", response.data);
    },
    async postFeedQueue(context, payload) {
        const { feedId, selectedQueueId } = payload;

        let postData = {
            FeedIds: Array.isArray(feedId) ? feedId : [feedId], 
            QueueId: selectedQueueId
        };

        await utils.utility.fetch(`api/Editor/SetFeedQueue`, "POST", null, postData);

        context.commit("setNewQueue", selectedQueueId);
    }
}